import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FindOptions } from 'api';
import {
  CheckDuplicateCustomerCodeQuery,
  CustomerApi,
  GenerateCustomerCodeQuery,
} from 'api/customer';

export const filterCustomer = createAsyncThunk(
  'customer/filterCustomer',
  async (option: FindOptions, { rejectWithValue }) => {
    try {
      const response = await CustomerApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterZNSCustomers = createAsyncThunk(
  'customer/filterZNSCustomers',
  async (option: FindOptions, { rejectWithValue }) => {
    try {
      const response = await CustomerApi.filterZNS(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findCustomerInChainEntities = createAsyncThunk(
  'customer/filterCustomer',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await CustomerApi.findCustomerInChainEntities(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findCustomerGroupOfCustomer = createAsyncThunk(
  'customer/filterCustomer',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await CustomerApi.findCustomerGroupOfCustomer(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createCustomer = createAsyncThunk(
  'customer/createCustomer',
  async (body: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await CustomerApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createUserForCustomer = createAsyncThunk(
  'customer/createUserForCustomer',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await CustomerApi.createUserForCustomer(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const sendZNSCustomers = createAsyncThunk(
  'customer/sendZNSCustomers',
  async (body: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await CustomerApi.sendZNS(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneCustomer = createAsyncThunk(
  'customer/findOneCustomer',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await CustomerApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findInformationCustomerForCRM = createAsyncThunk(
  'customer/findInformationCustomerForCRM',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await CustomerApi.findCustomerForCRM(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findUserConnectCustomer = createAsyncThunk(
  'customer/findUserConnectCustomer',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await CustomerApi.findUserConnectCustomer(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const connectUserAccount = createAsyncThunk(
  'customer/connectUserAccount',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await CustomerApi.connectUserAccount(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findPurchaseInformationCustomer = createAsyncThunk(
  'customer/findPurchaseInformationCustomer',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await CustomerApi.findPurchaseInformation(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityCustomer = createAsyncThunk(
  'customer/createEntityCustomer',
  async (body: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await CustomerApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCustomer = createAsyncThunk(
  'customer/updateCustomer',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await CustomerApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCustomerStatus = createAsyncThunk(
  'customer/updateCustomerStatus',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await CustomerApi.updateStatus(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteCustomer = createAsyncThunk(
  'customer/deleteCustomer',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await CustomerApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const generateCustomerCode = createAsyncThunk(
  'customer/generateCustomerCode',
  async (query: GenerateCustomerCodeQuery, { rejectWithValue }) => {
    try {
      const response = await CustomerApi.generateCode(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkDuplicateCustomerCode = createAsyncThunk(
  'customer/checkDuplicateCustomerCode',
  async (query: CheckDuplicateCustomerCodeQuery, { rejectWithValue }) => {
    try {
      const response = await CustomerApi.checkDuplicate(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteMultiCustomer = createAsyncThunk(
  'customer/deleteMultiCustomer',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await CustomerApi.deleteMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const exportCustomer = createAsyncThunk(
  'customer/exportCustomer',
  async (params: { customerIDs?: string[] }, { rejectWithValue }) => {
    try {
      const { customerIDs: ids } = params;
      const response = await CustomerApi.exportCustomer(ids);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    reloadCustomer(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationCustomer(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListCustomer(state, action) {
      state.savedList = action.payload;
    },
  },
});

const { actions, reducer: customerReducer } = customerSlice;

export const {
  reloadCustomer,
  updateSavedPaginationCustomer,
  updateSavedListCustomer,
} = actions;

export default customerReducer;
